export default "__VITE_ASSET__BMQP2CJG__"